// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c593c9342e70d961f33b","655":"efc51bfae9a59f506088"}[chunkId] + ".js";
};